import React from 'react';
import { Button, createStyles, Grid, makeStyles, TextField, Typography } from '@material-ui/core';

import { UserContext } from '../UserContext';
import { validateEmail } from '../../../shared/operators';
import { UserModel } from '../../../Models/UserModel';

export interface ISendEmailProps {
    onClick: () => void
    onBack: () => void
}

const useStyles = makeStyles(() => createStyles({
    container: {
        width: '430px'
    },
    itens: {
        marginTop: '20px',
        width: '100%'
    },
    textLink: {
        margin: '4px',
        cursor: 'pointer'
    }
}));

export function SendEmail({ onClick, onBack }: ISendEmailProps) {
    const classes = useStyles();

    const userContext = React.useContext(UserContext);

    const [errorEmail, setErrorEmail] = React.useState<boolean>(false);

    const handleChange = (prop: keyof UserModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const email = event.target.value;
        userContext.setUser({ ...userContext.user, [prop]: email });
        setErrorEmail(!validateEmail(email ?? ''));
    };

    const getDisabledSubmit = () => {
        return errorEmail || !userContext.user.email;
    };

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-start"
            className={classes.container}>
            <Typography
                variant='subtitle2'
                className={classes.textLink}
                onClick={onBack}>
                Voltar
            </Typography>
            <Typography
                variant='h3'
                color="textPrimary">
                Recuperação de senha
            </Typography>
            <Typography
                variant='body1'
                color="textSecondary">
                Informe o e-mail utilizado no login para que possamos confirmar sua senha.
            </Typography>
            <Grid
                item
                xs={12}
                className={classes.itens}>
                <TextField
                    fullWidth
                    id="user-email"
                    label="Email"
                    variant="outlined"
                    value={userContext.user.email}
                    error={errorEmail}
                    helperText={errorEmail ? (userContext.user.email ? 'O email inserido não é válido.' : 'Campo obrigatório') : ''}
                    onChange={handleChange('email')} />
            </Grid>
            <Button
                size="large"
                variant="contained"
                color="primary"
                fullWidth
                className={classes.itens}
                onClick={onClick}
                disabled={getDisabledSubmit()}>
                ENVIAR CÓDIGO
            </Button>
        </Grid>
    );
}
